import { buildModelManager } from "../builder.js";
const DefaultCampaignStatsSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  createdAt: true,
  delivered30days: true,
  delivered7days: true,
  delivered90days: true,
  deliveredLastMonth: true,
  deliveredLastYear: true,
  deliveredThisMonth: true,
  deliveredThisWeek: true,
  deliveredThisYear: true,
  deliveredToday: true,
  externalTurnover30days: true,
  externalTurnover7days: true,
  externalTurnover90days: true,
  externalTurnoverLastMonth: true,
  externalTurnoverLastYear: true,
  externalTurnoverThisMonth: true,
  externalTurnoverThisWeek: true,
  externalTurnoverThisYear: true,
  externalTurnoverToday: true,
  messagesCount30days: true,
  messagesCount7days: true,
  messagesCount90days: true,
  messagesCountLastMonth: true,
  messagesCountLastYear: true,
  messagesCountThisMonth: true,
  messagesCountThisWeek: true,
  messagesCountThisYear: true,
  messagesCountToday: true,
  optoutCount30days: true,
  optoutCount7days: true,
  optoutCount90days: true,
  optoutCountLastMonth: true,
  optoutCountLastYear: true,
  optoutCountThisMonth: true,
  optoutCountThisWeek: true,
  optoutCountThisYear: true,
  optoutCountToday: true,
  read30days: true,
  read7days: true,
  read90days: true,
  readLastMonth: true,
  readLastYear: true,
  readThisMonth: true,
  readThisWeek: true,
  readThisYear: true,
  readToday: true,
  sales30days: true,
  sales7days: true,
  sales90days: true,
  salesLastMonth: true,
  salesLastYear: true,
  salesThisMonth: true,
  salesThisWeek: true,
  salesThisYear: true,
  salesToday: true,
  sent30days: true,
  sent7days: true,
  sent90days: true,
  sentLastMonth: true,
  sentLastYear: true,
  sentThisMonth: true,
  sentThisWeek: true,
  sentThisYear: true,
  sentToday: true,
  totalWhatsappCostInEuros30days: true,
  totalWhatsappCostInEuros7days: true,
  totalWhatsappCostInEuros90days: true,
  totalWhatsappCostInEurosLastMonth: true,
  totalWhatsappCostInEurosLastYear: true,
  totalWhatsappCostInEurosThisMonth: true,
  totalWhatsappCostInEurosThisWeek: true,
  totalWhatsappCostInEurosThisYear: true,
  totalWhatsappCostInEurosToday: true,
  turnover30days: true,
  turnover7days: true,
  turnover90days: true,
  turnoverLastMonth: true,
  turnoverLastYear: true,
  turnoverThisMonth: true,
  turnoverThisWeek: true,
  turnoverThisYear: true,
  turnoverToday: true,
  updatedAt: true
};
const modelApiIdentifier = "campaignStats";
const pluralModelApiIdentifier = "campaignStatss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByCampaign",
    findByField: "campaignId",
    findByVariableName: "campaignId",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByCampaign",
    findByField: "campaignId",
    findByVariableName: "campaignId",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignStatsSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCampaignStats",
    operationReturnType: "CreateCampaignStats",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      campaignStats: { required: false, type: "CreateCampaignStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignStatsSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCampaignStats",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateCampaignStatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignStatsSelection
  },
  {
    type: "action",
    operationName: "updateCampaignStats",
    operationReturnType: "UpdateCampaignStats",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      campaignStats: { required: false, type: "UpdateCampaignStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignStatsSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCampaignStats",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateCampaignStatsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignStatsSelection
  },
  {
    type: "action",
    operationName: "deleteCampaignStats",
    operationReturnType: "DeleteCampaignStats",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCampaignStats",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCampaignStats",
    operationReturnType: "UpsertCampaignStats",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      campaignStats: { required: false, type: "UpsertCampaignStatsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCampaignStatsResult": { hasReturnType: false },
      "... on UpdateCampaignStatsResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignStatsSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCampaignStats",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertCampaignStatsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCampaignStatsSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "campaignStatsGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CampaignStatsManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCampaignStatsSelection,
  operations
);
export {
  CampaignStatsManager,
  DefaultCampaignStatsSelection
};
//# sourceMappingURL=CampaignStats.js.map
